export default __webpack_public_path__ + "static/media/042-snowboard.cae72b18.svg";